import axios from "axios";

const setAuthorizationToken = (token) => {
  return (axios.defaults.headers.common["x-access-token"] = token);
};

export default setAuthorizationToken;
